var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLipshape = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.951 40.014c.021-.101.038-.163.038-.17a.826.826 0 0 0-.55-.92c-.106-.036-10.403-3.555-16.77-8.222-2.075-1.523-4.878-1.699-6.97-.438-1.126.678-2.174.678-3.3 0-2.101-1.259-4.902-1.085-6.975.438-6.366 4.668-16.662 8.186-16.77 8.223a.828.828 0 0 0-.523 1.035.757.757 0 0 0 .058.238c.583 2.276 4.756 14.912 25.854 14.912S67.38 42.319 67.918 40.16a1.19 1.19 0 0 0 .037-.143l-.004-.004Zm-33.553-7.979c1.546-1.132 3.613-1.275 5.153-.355 1.645.99 3.354.984 5 0 1.533-.92 3.603-.777 5.149.355 4.936 3.62 11.922 6.489 15.281 7.758-1.556.343-4.196.546-8.117-.343-.329-.085-8.11-2.049-12.113.703l-.01.01s-.01 0-.01.006c-2.626 1.947-5.245.079-5.377-.016-3.995-2.752-11.784-.788-12.092-.71-3.932.896-6.578.693-8.138.35 3.355-1.265 10.346-4.132 15.277-7.751l-.003-.007Zm7.645 21.425c-17.218 0-22.367-8.456-23.801-12.181 1.73.471 4.762.814 9.403-.244.074-.02 7.381-1.863 10.742.45.747.556 2.148 1.201 3.762 1.201 1.123 0 2.344-.312 3.53-1.18h.007c3.376-2.323 10.695-.488 10.79-.46 2.233.508 4.095.692 5.62.692 1.63 0 2.87-.211 3.762-.455-1.434 3.73-6.587 12.181-23.805 12.181l-.01-.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.383 50.757c-3.063.767-6.55 0-6.587 0a.822.822 0 0 0-.984.624.822.822 0 0 0 .624.984c.105.02 1.761.39 3.867.39 1.09 0 2.303-.1 3.481-.39a.825.825 0 0 0-.403-1.598l.002-.01Z"
  }))));
};
export { SvgLipshape as ReactComponent };